var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 11L11 19.7Z",
    fill: "#F6D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C14.3975 14.3975 16.3024 16.3024 19.7 19.7Z",
    fill: "#F6D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 11L11 19.7M11 11C14.3975 14.3975 16.3024 16.3024 19.7 19.7M29.85 15.35C29.85 23.3581 23.3581 29.85 15.35 29.85C7.34185 29.85 0.849976 23.3581 0.849976 15.35C0.849976 7.34185 7.34185 0.849976 15.35 0.849976C23.3581 0.849976 29.85 7.34185 29.85 15.35Z",
    stroke: "#FF0000",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendedIcon);
export default __webpack_public_path__ + "static/media/suspended-icon.a555c8b39a6fced9880b765fe8327aa1.svg";
export { ForwardRef as ReactComponent };